import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import IconeAjuda from '@/global/components/IconeAjuda'
import { Link } from '@/global/components/Link'
import Grid from '@/global/components/ui/Grid'
import { FormFieldCheckbox } from 'global/components/Form'
import { useLocation } from 'react-router-dom'
import { useStore } from 'store'

export const ExportacaoFolha = () => {
    const { pathname } = useLocation()

    const empresaId = useStore(state => state.companyId)
    const funcionarioId = useStore(state => state.employeeId)

    const codigo = useStore(state => state.company?.codEmpresaFolha)

    const to = `/cadastros/empresas/${empresaId}/editar`

    const searchParams = new URLSearchParams({
        aba: 'ponto',
    })

    const handleTo = () => {
        return to + '?' + searchParams.toString() + '#codEmpresaFolha'
    }

    if (pathname.includes('editar')) {
        searchParams.set(
            'voltar',
            `/cadastros/funcionarios/${funcionarioId}/editar`,
        )
    } else if (pathname.includes('adicionar')) {
        searchParams.set('voltar', '/cadastros/funcionarios/adicionar')
    }

    return (
        <section id="exportacao-folha">
            <HorizontalDivider>
                <span className="inline-flex items-center my-3">
                    Exportar para a folha de pagamento&nbsp;
                    <IconeAjuda>
                        Para exportar os dados para a folha de pagamento, é
                        necessário que o código da empresa seja informado.{' '}
                        <Link href={handleTo()}>Alterar cadastro</Link>
                    </IconeAjuda>
                </span>
            </HorizontalDivider>
            <Grid container>
                <Grid item xs={4}>
                    <FormFieldCheckbox
                        name="expFolhaHorasExtras"
                        label="Horas extras"
                        defaultChecked
                        disabled={!codigo}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldCheckbox
                        name="expFolhaFaltas"
                        label="Faltas"
                        defaultChecked
                        disabled={!codigo}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldCheckbox
                        name="expFolhaAdicionalNoturno"
                        label="Adicional noturno"
                        defaultChecked
                        disabled={!codigo}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldCheckbox
                        name="expFolhaHorasNormais"
                        label="Horas normais"
                        defaultChecked
                        disabled={!codigo}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldCheckbox
                        name="expFolhaHorasTrabalhar"
                        label="Horas a trabalhar"
                        defaultChecked
                        disabled={!codigo}
                    />
                </Grid>
            </Grid>
        </section>
    )
}
